import "./styles.css";
import { mountApp } from "./ui/app.ts";

mountApp(document.querySelector("#app"));

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/service-worker.js");
  });
}
